import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getCashRegisters = async (branchId, params = {}) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers`,
    { ...withAuth(), params }
  )).data;

export const getCashRegisterSessions = async (branchId, params = {}) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers/sessions`,
    { ...withAuth(), params }
  )).data;

export const getCashRegisterEvents = async (branchId, params = {}) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers/events`,
    { ...withAuth(), params }
  )).data;

export const getCashRegisterExpectedCash = async (branchId, cashRegisterId) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/expected-cash`,
    withAuth()
  )).data;

export const getCashRegisterOpenSales = async (branchId, cashRegisterId) =>
  (await axios.get(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/open-sales`,
    withAuth()
  )).data;

export const createCashRegister = async (branchId, payload) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers`,
    payload,
    withAuth()
  )).data;

export const updateCashRegister = async (branchId, cashRegisterId, payload) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}`,
    payload,
    withAuth()
  )).data;

export const deactivateCashRegister = async (branchId, cashRegisterId) =>
  (await axios.delete(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}`,
    withAuth()
  )).data;

export const restoreCashRegister = async (branchId, cashRegisterId) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/restore`,
    {},
    withAuth()
  )).data;

export const setCashRegisterUsers = async (branchId, cashRegisterId, users) =>
  (await axios.put(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/users`,
    { users },
    withAuth()
  )).data;

export const updateCashRegisterClientTypes = async (branchId, cashRegisterId, allowedClientTypes) =>
  (await axios.put(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/client-types`,
    { allowedClientTypes },
    withAuth()
  )).data;

export const updateCashRegisterDiscountApprover = async (branchId, cashRegisterId, discountApproverUserId) =>
  (await axios.put(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/discount-approver`,
    { discountApproverUserId },
    withAuth()
  )).data;

export const updateCashRegisterMaxOpenSales = async (branchId, cashRegisterId, maxOpenSales) =>
  (await axios.put(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/max-open-sales`,
    { maxOpenSales },
    withAuth()
  )).data;

export const openCashRegisterSession = async (branchId, cashRegisterId, openingCash) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/open`,
    { openingCash },
    withAuth()
  )).data;

export const closeCashRegisterSession = async (branchId, cashRegisterId, payload) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/close`,
    payload,
    withAuth()
  )).data;
